import React, { useContext } from 'react';
import ModalModule from '../modal';
import AccountVerify from './AccountVerify.component';

const { Modal, ModalContext, ModalButtonActionType } = ModalModule;

const AccountVerificationModal = ({
	modalId,
	data: { completionCallback, isChangingEmailAddress, emailOnly },
}) => {
	const { closeModal } = useContext(ModalContext);

	const completeCallback = status => {
		completionCallback(status);

		// close the modal
		closeModal(modalId, ModalButtonActionType.Ok);
	};

	const handleClose = () => {
		completionCallback(false);
	};

	return (
		<Modal
			modalId={modalId}
			header="Account Verification"
			className="account-verification-modal"
			hideFooter
			onCloseButtonClick={handleClose}
		>
			<div className="body">
				<AccountVerify
					completionCallback={completeCallback}
					isChangingEmailAddress={isChangingEmailAddress || false}
					emailOnly={emailOnly || false}
				/>
			</div>
		</Modal>
	);
};

export default AccountVerificationModal;
